var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1019_131273)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6.94727,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#3763D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4432 20.9132C40.1602 20.7919 39.8398 20.7919 39.5568 20.9132L40.6916 23.4676L47.6441 26.4473L44.8068 27.6632C44.3932 27.8405 44.125 28.2472 44.125 28.6973V30.212C43.976 30.1806 43.8165 30.1495 43.6465 30.1193L44.8069 32.7313L44.8129 32.7339C45.159 32.8799 45.5554 32.8434 45.8693 32.6365C46.185 32.4283 46.375 32.0754 46.375 31.6973V29.4391L49.375 28.1534V32.4473C49.375 33.0686 49.8787 33.5723 50.5 33.5723C51.1213 33.5723 51.625 33.0686 51.625 32.4473V26.4473C51.625 25.9972 51.3568 25.5905 50.9432 25.4132L40.4432 20.9132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.875 30.212V28.6973C35.875 28.2472 35.6068 27.8405 35.1932 27.6632L32.3559 26.4473L38.4829 23.8214L40 23.1712L40.6916 23.4676L39.5568 20.9132L29.0568 25.4132C28.6432 25.5905 28.375 25.9972 28.375 26.4473C28.375 26.8973 28.6432 27.304 29.0568 27.4813L33.625 29.4391V31.6973C33.625 32.0754 33.815 32.4283 34.1307 32.6365C34.4462 32.8445 34.845 32.8802 35.1924 32.7316L36.1428 30.1582C36.0501 30.1759 35.9608 30.1939 35.875 30.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.25 33.1973V31.6973V29.4473H34.75V31.6973V33.1973C34.75 36.0968 37.1005 38.4473 40 38.4473C42.8995 38.4473 45.25 36.0968 45.25 33.1973Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0798 43.0468C37.3142 40.4128 42.6863 40.4128 46.9205 43.0468C47.0488 43.1265 47.2101 43.2216 47.3948 43.3303C48.2236 43.8183 49.5224 44.5831 50.4092 45.4899C50.9664 46.0597 51.5105 46.8252 51.6095 47.7711C51.715 48.7792 51.2916 49.7205 50.4624 50.5458C49.0788 51.9228 47.3747 53.0713 45.1442 53.0713H34.8562C32.6258 53.0713 30.9217 51.9228 29.5381 50.5458C28.7089 49.7205 28.2854 48.7792 28.3909 47.7712C28.4899 46.8252 29.0339 46.0597 29.5911 45.4899C30.478 44.5831 31.7767 43.8184 32.6055 43.3303C32.7902 43.2216 32.9516 43.1265 33.0798 43.0468ZM34.2683 44.9573C34.0628 45.0851 33.8412 45.2165 33.6117 45.3526C32.7836 45.8437 31.852 46.3962 31.1997 47.0631C30.7982 47.4737 30.6514 47.7883 30.6287 48.0053C30.6125 48.1602 30.6365 48.4646 31.1252 48.951C32.3168 50.1369 33.4808 50.8213 34.8562 50.8213H45.1442C46.5196 50.8213 47.6836 50.1369 48.8752 48.951C49.3639 48.4646 49.3879 48.1602 49.3717 48.0053C49.349 47.7883 49.2022 47.4737 48.8006 47.0631C48.1484 46.3962 47.2168 45.8437 46.3886 45.3526C46.1591 45.2165 45.9376 45.0851 45.7321 44.9573C42.2255 42.776 37.775 42.776 34.2683 44.9573Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1019_131273",
    x: 0,
    y: 0.947266,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1019_131273"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1019_131273",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.79257f31e3b9dbabf3e784ee7d3de172.svg";
export { ForwardRef as ReactComponent };